import React from 'react';
import {
  WidgetInstruction,
  WidgetInstructionBody,
  WidgetInstructionDescription,
  WidgetInstructionFooter,
  WidgetInstructionHeader,
  WidgetInstructionImg,
  WidgetInstructionInfo,
  WidgetInstructionNumber,
  WidgetInstructionTitle
} from '@/components/custom/widget';
import { Button } from '@/components/ui/button';

export function InstructionWidget({ data }) {
  return (
    <WidgetInstruction>
      <WidgetInstructionHeader>
        <WidgetInstructionNumber>{data?.number}</WidgetInstructionNumber>
        <WidgetInstructionInfo>
          <WidgetInstructionTitle>{data?.title}</WidgetInstructionTitle>
          {data?.type === 'list' ? (
            <ul style={{ listStyle: 'outside' }}>
              {data?.description?.map(item => (
                <li>{item}</li>
              ))}
            </ul>
          ) : (
            <WidgetInstructionDescription>{data?.description}</WidgetInstructionDescription>
          )}
          {data?.cta && (
            <WidgetInstructionFooter>
              <Button
                variant="outline"
                size="sm"
                asChild
              >
                <a
                  href="/redacao.pdf"
                  download="/redacao.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {data.cta.text}
                </a>
              </Button>
            </WidgetInstructionFooter>
          )}
        </WidgetInstructionInfo>
      </WidgetInstructionHeader>

      {data?.img && (
        <WidgetInstructionBody>
          <WidgetInstructionImg
            src={data?.img}
            alt=""
          />
        </WidgetInstructionBody>
      )}
    </WidgetInstruction>
  );
}
